import React from 'react';

import { Icon } from '@chakra-ui/react';

export const ExportToSIEMIcon = props => (
  <Icon
    viewBox="0 0 188.053 188.053"
    color="inherit"
    h="full"
    w="full"
    {...props}
  >
    <g>
      <path
        d="M46.447,3.164H7.5c-4.142,0-7.5,3.358-7.5,7.5v38.947c0,4.142,3.358,7.5,7.5,7.5h38.947
		c4.142,0,7.5-3.358,7.5-7.5V10.664C53.947,6.522,50.589,3.164,46.447,3.164z M38.947,42.111H15V18.164h23.947V42.111z"
      />
      <path
        d="M113.5,3.164H74.553c-4.142,0-7.5,3.358-7.5,7.5v38.947c0,4.142,3.358,7.5,7.5,7.5H113.5
		c4.142,0,7.5-3.358,7.5-7.5V10.664C121,6.522,117.642,3.164,113.5,3.164z M106,42.111H82.053V18.164H106V42.111z"
      />
      <path
        d="M180.553,3.164h-38.947c-4.142,0-7.5,3.358-7.5,7.5v38.947c0,4.142,3.358,7.5,7.5,7.5h38.947
		c4.142,0,7.5-3.358,7.5-7.5V10.664C188.053,6.522,184.695,3.164,180.553,3.164z M173.053,42.111h-23.947V18.164h23.947V42.111z"
      />
      <path
        d="M46.447,67.053H7.5c-4.142,0-7.5,3.358-7.5,7.5V113.5c0,4.142,3.358,7.5,7.5,7.5h38.947
		c4.142,0,7.5-3.358,7.5-7.5V74.553C53.947,70.411,50.589,67.053,46.447,67.053z M38.947,106H15V82.053h23.947V106z"
      />
      <path
        d="M113.5,67.053H74.553c-4.142,0-7.5,3.358-7.5,7.5V113.5c0,4.142,3.358,7.5,7.5,7.5H113.5
		c4.142,0,7.5-3.358,7.5-7.5V74.553C121,70.411,117.642,67.053,113.5,67.053z M106,106H82.053V82.053H106V106z"
      />
      <path
        d="M180.553,67.053h-38.947c-4.142,0-7.5,3.358-7.5,7.5V113.5c0,4.142,3.358,7.5,7.5,7.5h38.947
		c4.142,0,7.5-3.358,7.5-7.5V74.553C188.053,70.411,184.695,67.053,180.553,67.053z M173.053,106h-23.947V82.053h23.947V106z"
      />
      <path
        d="M46.447,130.941H7.5c-4.142,0-7.5,3.358-7.5,7.5v38.947c0,4.142,3.358,7.5,7.5,7.5h38.947
		c4.142,0,7.5-3.358,7.5-7.5v-38.947C53.947,134.299,50.589,130.941,46.447,130.941z M38.947,169.889H15v-23.947h23.947V169.889z"
      />
      <path
        d="M113.5,130.941H74.553c-4.142,0-7.5,3.358-7.5,7.5v38.947c0,4.142,3.358,7.5,7.5,7.5H113.5
		c4.142,0,7.5-3.358,7.5-7.5v-38.947C121,134.299,117.642,130.941,113.5,130.941z M106,169.889H82.053v-23.947H106V169.889z"
      />
      <path
        d="M180.553,130.941h-38.947c-4.142,0-7.5,3.358-7.5,7.5v38.947c0,4.142,3.358,7.5,7.5,7.5h38.947
		c4.142,0,7.5-3.358,7.5-7.5v-38.947C188.053,134.299,184.695,130.941,180.553,130.941z M173.053,169.889h-23.947v-23.947h23.947
		V169.889z"
      />
    </g>
  </Icon>
);
